import { initializeApp } from "firebase/app";
import { getFirestore } from 'firebase/firestore'

import { getAnalytics } from "firebase/analytics";

const firebaseConfig = {
  apiKey: "AIzaSyARPHdH-EPLEOTjUo9aBoQc12wBJI2zZEs",
  authDomain: "yaskiaweb-78ef1.firebaseapp.com",
  projectId: "yaskiaweb-78ef1",
  storageBucket: "yaskiaweb-78ef1.firebasestorage.app",
  messagingSenderId: "336123560564",
  appId: "1:336123560564:web:e904eb42710e3fb51cc721",
  measurementId: "G-WZ9Y15VHKM"
};

const app = initializeApp(firebaseConfig);

export const analytics = getAnalytics();

export const db = getFirestore(app);

